import $ from 'jquery'
import 'select2'

document.addEventListener("turbo:before-cache", function() {
  $('.collapse').collapse('hide')
  $('.js-select2').select2('destroy')
})
